import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/CreateCheckoutSession', 'post'>;
type ResponseBody = OASOutput<O, '/api/CreateCheckoutSession', 'post'>;

type Params = {
  lookupKey: string;
  successUrl: string;
  cancelUrl: string;
};

type Result = string;

export const generateCheckoutSessionFactory = (apiClient: ApiClient) => {
  const generateCheckoutSession = async (variables: Params): Promise<Result> => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/CreateCheckoutSession'].post(requestParams);
    const responseBody = await response.json();
    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      json: {
        lookupKey: input.lookupKey,
        successUrl: input.successUrl,
        cancelUrl: input.cancelUrl,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return response;
  };

  return generateCheckoutSession;
};
